"use strict";
/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPageAuthenticationConditionTextType = void 0;
exports.FormPageAuthenticationConditionTextType = {
    Equal: 'equal',
    NotEqual: 'notEqual',
    ContainsAll: 'containsAll',
    ContainsAny: 'containsAny',
    NotContains: 'notContains',
    StartsWith: 'startsWith',
    EndsWith: 'endsWith',
    NotStartsWith: 'notStartsWith',
    NotEndsWith: 'notEndsWith',
    In: 'in',
    NotIn: 'notIn',
    Present: 'present',
    NotPresent: 'notPresent'
};
